import _axios from '@/utils/request';

// 验证码登录
export function loginCode(phone, password) {
    return _axios('post', `/woauth2/oauth/token?grant_type=dynamic_password&username=${phone}&password=${password}`);
}

// 工号登录
export function login(username, password) {
    return _axios('post', `/woauth2/oauth/token?grant_type=password&username=${username}&password=${password}`);
}

export function postVerification(param) {
    return _axios('post', `/woauth2/oauth/dynamic_password`, param);
}

// 密码强度低 修改密码
export function putChangeWeakPassword(params) {
    return _axios('put', `/ms-shulan-hospital/v1/doctor/changeWeakPassword`, params);
}
//根据工号发送验证码
export function postByStaffNo(param) {
    return _axios('post', `/oauth/verification/code/send/by/staffNo`, param);
}
//根据手机号发送短信
export function postBycode(param) {
    return _axios('post', `/oauth/dynamic/password/code/send`, param);
}
//接口参数加密登录

export function oauthTokenLogin(param) {
    return _axios('post', `/oauth/token/post`, param);
}
